export default "__VITE_PUBLIC_ASSET__d7fb92a3__"